import * as HLF from "html-living-framework";
import { OutlineFilter } from "Filters/OutlineFilter";
import { Button } from "GameObjects/UI/Button";
import { LayoutButton } from "GameObjects/UI/LayoutButton";
import { RestStopGame } from "States/RestStopGame";
import { StressorType } from "Data/StressorType";

export class StressorButton extends Button {
    public stressorType?: StressorType;
    public tallied: boolean = false;
    public readonly checkMark = this._visuals.addChild(HLF.PixiUtils.makeSprite("cyberchase-reststop-tally-check"));
    public readonly outline = new OutlineFilter(2, 0xffffff, HLF.Application.instance.renderer.resolution);

    constructor (
        pCallback: () => void,
        pAsset: string,
        pOverAsset: string,
        pDownAsset: string,
        pHoverVO: string,
        pClickedSFX: string,
    ) {
        super(pCallback, pAsset, pOverAsset, pDownAsset, pHoverVO, pClickedSFX);
        this._visuals.filters = [this.outline];
        this.checkMark.position.set(this._image!.width / 2, this._image!.height / 2);
        this.checkMark.visible = false;
        this.outline.enabled = true;

        if (HLF.PlatformUtils.isMobile()) {
            this.hitArea = new PIXI.Circle(0, 0, 30);
        }
    }

    public get hoverVO() {
        return this._hoverVO;
    }
}